import AppRecord from './AppRecord.js'

class LaunderingEvent extends AppRecord {
  get event(){
    return this.constructor.employeeStore.events.find(ev => ev.id === this.id)||{}
  }
  set event(ev){
    this.eventsController.changeDatum(ev)
  }
  get eventsController(){
    return this.constructor.employeeStore.controllers.EventsController
  }
  get account_name(){
    if(this.event.account){
      return this.event.account.name
    } else {
      return undefined
    }
  }
  get person(){
    return this.constructor.employeeStore.employees.find(ev => ev.id === this.person_id)||{}
  }
  get eventOwner(){
    if (this.event && this.event.account && this.event.account.entity){
      return this.event.account.entity.long_name
    }
    return ""
  }
}

export default LaunderingEvent
